<template>
    <div id="job-index">
        <header-section :subnav_show="false" :change_color="true"></header-section>
        <!-- ======= Hero Section ======= -->
        <div id="hero-job" data-aos="zoom-out" data-aos-delay="100"></div>
        <div class="container">
            <div class="section-title">
                <h2>人才招聘</h2>
                <p>JOBS</p>
            </div>
            <el-row :gutter="15">
                <el-col :span="18">
                    <ul v-if="this.reDataList.length > 0">
                        <li v-for="(bean, index) in reDataList" :key="index" class="job-list-items">
                            <p class="item-title">
                                <a :href="'/job/detail/' + bean.id" target="_blank">{{ bean.jobName }}</a>
                                <span v-if="bean.jipin == 1" class="job-jipin">急</span>
                                <span class="job-base-filter"> {{ bean.jobExperiences }} | {{ bean.education }} |
                                    {{ bean.jobNumber }}人 </span>
                            </p>
                            <p class="job-summary">
                                {{ bean.jobRequirement }}
                            </p>
                            <div class="job-tips">
                                <span class="job-tips-span"><i class="el-icon-position"></i> {{ bean.workPlace }}
                                </span>
                                <span class="job-tips-span"><i class="el-icon-user"></i> {{ bean.categoryName }}</span>
                                <span class="job-tips-span"><i class="el-icon-time"></i> 全职</span>
                                <span class="job-tips-span"><i class='el-icon-lollipop'></i> {{ bean.jobWelfare }}</span>
                                <span class="jobtips-span float_right"><a :href="'/job/detail/' + bean.id"
                                        class="job-link" target="_blank"><i class="el-icon-link"></i>
                                        查看详情</a></span>
                            </div>
                        </li>
                    </ul>
                    <!-- empty -->
                    <div v-else class="home_empty_list">
                        <i class="font iconfont">&#xe600;</i>暂无相关数据！
                    </div>
                    <!--pager-->
                    <div class="pager_block" style="clear: both;" v-if="this.reDataList.length > 0">
                        <el-pagination @current-change="current_change" background
                            layout="total, prev, pager, next, jumper" :total="total_data" :page-size="page_size"
                            :current-page="current_page"></el-pagination>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="right-sidebar">
                        <h5 class="sidebar-title"><i class="el-icon-tickets"></i> 职位类别</h5>
                        <div class="sidebar-item">
                            <div @click="queryParam.categoryId ='';current_page = 1;getJobPageList()">
                                <a href="javascript:void(0)"
                                    :class="queryParam.categoryId == '' ? 'active-link' : ''">
                                    全部
                                </a>
                            </div>
                            <div v-for="(v, k) in reCategoryList" :key="k" @click="queryParam.categoryId = v.id;current_page = 1;getJobPageList(v)">
                                <a href="javascript:void(0)"
                                    :class="queryParam.categoryId == v.id ? 'active-link' : ''">
                                    {{ v.categoryName }}
                                </a>
                            </div>
                        </div>

                        <h5 class="sidebar-title"><i class="el-icon-user"></i> 急聘岗位</h5>
                        <div class="sidebar-item">
                            <div v-for="(v, k) in reJiPinList" :key="k">
                                <span>{{k+1}}、</span>
                                <router-link :to="'/job/detail/' + v.id">
                                    {{ v.jobName }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- footer -->
        <footer-section></footer-section>
    </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
    components: {
        HeaderSection,
        FooterSection
    },
    props: {},
    data() {
        return {
            queryParam: {
                categoryId: '',
                isShow: 1,
                page: 1,
                limit: 10
            },
            //当前栏目id
            //currChannelId: 111,

            current_page: 1,
            page_size: 10,
            total_pages: 0,
            total_data: 0,

            reDataList: [],
            reCategoryList: [],
            reJiPinList: []
        };
    },
    // watch: {
    //     '$route'() {
    //   this.queryParam.categoryId = this.$route.params.id;
    //   this.getJobPageList();
    // }
    // },
    computed: {
    },
    methods: {
        getJobPageList(v) {
            if (v) {
                //添加标题和meta标签
                document.title =v.categoryName + '-河北科瑞达仪器科技股份有限公司'
                let m = document.querySelectorAll('meta');
                const meta = document.createElement('meta')
                meta.name = 'keywords'
                meta.content = v.categoryName
                
                m[0].after(meta)
                for(let i=0;i<m.length;i++){
                    if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                        m[i].remove()
                    }
                }
            }
            this.queryParam.page = this.current_page
            this.$get(this.$api.getJobPageList, this.queryParam).then(response => {
                if (response.code === 0) {
                    this.reDataList = response.data.list;
                    this.page_size = response.data.pagesize;
                    this.total_pages = response.data.totalpages;
                    this.total_data = response.data.totalrecords;
                    this.loading = false
                } else {
                    window.console.log(response.msg);
                }
            });
        },
        getJobCategoryList() {
            this.$get(this.$api.getJobCategoryList).then(res => {
                if (res.code === 0) {
                    this.reCategoryList = res.data;
                    this.loading = false
                } else {
                    window.console.log(res.msg);
                }
            });
        },
        getJobJiPinList() {
            this.$get(this.$api.getJobJiPinList).then(res => {
                if (res.code === 0) {
                    this.reJiPinList = res.data;
                    this.loading = false
                } else {
                    window.console.log(res.msg);
                }
            });
        },
        // 分页改变
        current_change: function (e) {
            this.current_page = e;
            this.getJobPageList();
        },
    },
    created() {
        this.getJobPageList();
        this.getJobCategoryList();
        this.getJobJiPinList();

        //添加标题和meta标签
        let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
        document.title='人才招聘-河北科瑞达仪器科技股份有限公司'
        let m = document.querySelectorAll('meta');
        const meta = document.createElement('meta')
        meta.name = 'keywords'
        for(let i=0;i<m.length;i++){
            arr.some(item => {
                if(item == m[i].content){
                    m[i].remove()
                }
            })
        }
        meta.content = '人才招聘'
        
        m[0].after(meta)
        for(let i=0;i<m.length;i++){
            if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                m[i].remove()
            }
        }
    },
    mounted() {
    }
};
</script>
<style scoped>
/deep/ .more{
    float: none;
}
>>> .el-pagination__jump{
    margin-left: 10px;
}

#job-index{
    overflow-x: hidden;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-job {
    width: 100%;
    height: 45vh;
    background: url("~@/static/img/banner/team-banner.jpg");
    background-size: cover;
    position: relative;
}

.job-list-items {
    border-bottom: 1px solid #dddddd;
    margin-bottom: 15px;
}

.item-title {
    height: 26px;
    line-height: 26px;
    overflow: hidden;
    font-size: 16px;
    color: #333;
    padding: 15px;
}

.item-title a {
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    font-size: 17px;
    font-weight: 700;
    color: #022668;
}

.item-title a:hover {
    color: rgb(247, 41, 5);
}

.job-base-filter {
    font-size: 14px;
    color: #999999;
    display: inline-block;
    padding: 3px;
    border: 1px solid #999999;
    border-radius: 2px;
    line-height: 12px;
    margin-left: 30px;
}

.job-jipin {
    box-sizing: border-box;
    text-align: center;
    position: absolute;
    /* top: -5px; */
    background: red;
    color: #fff;
    border-radius: 999px;
    /* padding: 0 0.5em; */
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    /* transform: scale(.7); */
    font-family: tahoma !important;
}

.job-summary {
    font-size: 14px;
	letter-spacing: 1px;
    color: #343435;
    padding: 15px;
}

.job-tips {
    padding: 15px 15px 15px 0;
    color: #343435;
}

.job-tips-span {
    margin: 10px;
    font-size: 14px;
    color: #343435;
}

.job-link {
    font-size: 14px;
    color: #022668;
    line-height: 25px;
}

.job-link:hover {
    font-size: 14px;
    color: rgb(247, 41, 5);
    line-height: 25px;
}

.h4 {
    font-weight: 500;
    margin-bottom: 5px;
    font-size: 16px;
    color: #1787fb;
}

.blue {
    color: #1787fb;
}

.blue a {
    color: #056bfb;
}

.blue a:hover {
    color: #008ffb;
}
</style>